import { WeightUnitEnum } from "@saleor/graphql";

export const CONDITION_TYPE = "ZN00";

export const WEIGHT_UNIT = {
  TON: WeightUnitEnum.TON,
  KG: WeightUnitEnum.KG
};
